import ShareMenu from './ShareMenu';

export default ShareMenu;
